import React from 'react';

export default function NotificationPanel({ notifications, unreadCount, onMarkRead, onMarkAllRead }) {
  return (
    <div className="card" style={{ height: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3>
          Notifications
          {unreadCount > 0 && (
            <span className="badge badge-rare" style={{ marginLeft: 8, fontSize: 11 }}>{unreadCount}</span>
          )}
        </h3>
        {unreadCount > 0 && (
          <button className="btn-secondary btn-small" onClick={onMarkAllRead}>Mark All Read</button>
        )}
      </div>
      {notifications.length === 0 ? (
        <div className="empty-state" style={{ padding: 20 }}>No notifications</div>
      ) : (
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          {notifications.map(n => (
            <div
              key={n.id}
              style={{
                padding: '8px 10px',
                borderBottom: '1px solid var(--border)',
                opacity: n.read_at ? 0.6 : 1,
                fontSize: 13,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: 8,
              }}
            >
              <div>
                <div style={{ color: 'var(--text-primary)' }}>{n.message}</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
              {!n.read_at && (
                <button className="btn-small btn-secondary" onClick={() => onMarkRead(n.id)} style={{ flexShrink: 0 }}>
                  Read
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
